import React, { useState } from 'react';
import { Waypoint } from 'react-waypoint';
import styled, { keyframes } from 'styled-components';
import { spaces } from '@99designs/emu/settings';
import { DWB21_Black, DWB21_Cream } from '../colors';

export interface PieChartProps {
    percentage: number;
    color?: string;
    height?: string;
    width?: string;
}

const ANIMATION_DURATION_IN_SEC = 6;
export default function PieChart({
    percentage,
    color = DWB21_Cream,
    height,
    width,
}: PieChartProps) {
    const piePercentage = percentage <= 0 || percentage > 100 ? 0 : percentage;
    const [percentageFill, setPercentageFill] = useState(0);
    const handleEntry = () => {
        setPercentageFill(piePercentage);
    };

    const handleExit = () => {
        setPercentageFill(0);
    };
    return (
        <Waypoint onEnter={handleEntry} onLeave={handleExit} topOffset={'10%'} bottomOffset={'5%'}>
            <Border height={height} width={width}>
                <Container>
                    <SVGContainer viewBox="0 0 64 64">
                        <Circle cx="32" cy="32" r="16" percentage={percentageFill} color={color} />
                    </SVGContainer>
                </Container>
            </Border>
        </Waypoint>
    );
}

const Border = styled.div<{ height: string | undefined; width: string | undefined }>`
    border: 1px solid ${DWB21_Black};
    border-radius: 50%;
    height: ${(props) => (props.height ? props.height : '100px')};
    width: ${(props) => (props.width ? props.width : '100px')};
    padding: ${spaces['0.75bu']};
`;

const Container = styled.figure`
    display: block;
    position: relative;
    width: 100%;
    height: auto;
    padding-top: 100%;
`;

const SVGContainer = styled.svg`
    display: block;
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    overflow: visible;
`;

const circleAnimation = (percentage: number) => keyframes`
    50%,
    100% {
        stroke-dasharray: ${percentage},
            ${100 - percentage}, 0, 0;
    }
`;

const Circle = styled.circle<{ percentage: number; color?: string }>`
    fill: rgba(0, 0, 0, 0);
    stroke-width: 31;
    stroke-dasharray: 0, 100, 0, 0;
    stroke-dashoffset: 25;
    animation: ${(props) => circleAnimation(props.percentage)} ${ANIMATION_DURATION_IN_SEC}s 1 ease
        both;
    stroke: ${(props) => props.color};
`;
